import { render, staticRenderFns } from "./AdminJobs.vue?vue&type=template&id=4e60df46&"
import script from "./AdminJobs.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AdminJobs.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AdminJobs.vue?vue&type=style&index=0&id=4e60df46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports